import LogoutButton from '@components/shared/LogoutButton/LogoutButton';
import { useTranslation } from '@/hooks/useTranslation';
import styles from './EmployeeCompletePage.module.scss';

function EmployeeCompletePage() {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <LogoutButton />
      </header>
      <div className={styles.content}>
        <p className={styles.message}>
          {t('K_EMPLOYEE_COMPLETE_MESSAGE', 'All the details are filled successfully.')}
        </p>
      </div>
    </div>
  );
}

export default EmployeeCompletePage;
